import type {
    AddressCardInfo,
    MessengerItem,
    TSitesDomain,
} from '~/types/global.types'

export const socialMedias: MessengerItem[] = [
    {
        icon: 'vk',
        alt: 'ВКонтакте',
        link: 'https://vk.com/cromiru',
    },
    {
        icon: 'dzen',
        alt: 'Дзен',
        link: 'https://dzen.ru/id/5f7343979feb4e69fd693626',
    },
    {
        icon: 'youtube',
        alt: 'Ютуб',
        link: 'https://www.youtube.com/channel/UCN1b1bjkIGxfxWqatuhWp8g',
    },
    {
        icon: 'rutube',
        alt: 'Рутуб',
        link: 'https://rutube.ru/channel/25014836/',
    },
    {
        icon: 'vc',
        alt: 'Виси',
        link: 'https://vc.ru/id3269306',
    },
]

interface Messengers {
    [key: string]: MessengerItem
}

export const messengers: Messengers = {
    telegram: {
        icon: 'telegram',
        alt: 'Телеграм',
        link: 'https://t.me/Cromi_bot',
    },
    whatsApp: {
        icon: 'whatsapp',
        alt: 'Ватсап',
        link: 'https://api.whatsapp.com/send?phone=9681895181&text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5,%20%D0%BC%D0%BD%D0%B5%20%D0%BD%D1%83%D0%B6%D0%BD%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%81%D1%83%D0%BB%D1%8C%D1%82%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BF%D0%BE%20%D0%BE%D0%B1%D0%BE%D1%80%D1%83%D0%B4%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8E',
    },
    max: {
        icon: 'max',
        alt: 'MAX',
        link: 'https://max.ru/id780608296104_bot',
    },
}
export const email = 'office@cromi.ru'

export const contacts = {
    msk: {
        title: 'Москва',
        address: 'ул. Кусковская, 20А',
        phone: '+7 499 499-60-30',
        tel: '+74994996030',
    },
    spb: {
        title: 'Санкт-Петербург',
        address: 'пр. Маршала Блюхера, 12к7',
        phone: '+7 812 490-60-30',
        tel: '+79124906030',
    },
    ru: {
        title: 'РФ',
        address: 'Звонок бесплатный',
        phone: '8 800 302-55-05',
        tel: '88003025505',
    },
}

export type TAddressCards = {
    [key in TSitesDomain]: AddressCardInfo[]
}

export const addressesCard: TAddressCards = {
    'cromi.ru': [
        {
            swiperClass: 'swiper-saint-contact',
            city: 'Санкт-Петербург',
            address: 'пр. Маршала Блюхера, 12к7',
            phone: '+7 812 490-60-30',
            tel: '+78124906030',
            email: 'info@cromi.ru',
            images: [
                {
                    url: '/assets/images/office/jpg-png/spb-1.jpg',
                    webp_url: '/assets/images/office/webp/spb-1.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-2.jpg',
                    webp_url: '/assets/images/office/webp/spb-2.webp',
                    alt: '',
                    width: 627,
                    height: 354,
                    mime_type: '',
                    title: '',
                    type: 'image',
                },
                {
                    url: '/assets/images/office/jpg-png/spb-3.jpg',
                    webp_url: '/assets/images/office/webp/spb-3.webp',
                    alt: '',
                    width: 627,
                    height: 354,
                    mime_type: '',
                    title: '',
                    type: 'image',
                },
                {
                    url: '/assets/images/office/jpg-png/spb-4.jpg',
                    webp_url: '/assets/images/office/webp/spb-4.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 627,
                    height: 354,
                },
            ],
        },
        {
            swiperClass: 'swiper-saint-contact',
            city: 'Москва',
            address: 'Кусковская улица, 20А',
            phone: '+7 499 499-60-30',
            tel: '+78124906030',
            email: 'info@cromi.ru',
            images: [
                {
                    url: '/assets/images/office/jpg-png/msc-1.jpg',
                    webp_url: '/assets/images/office/webp/msc-1.webp',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    alt: '',
                    width: 628,
                    height: 387,
                },
                {
                    url: '/assets/images/office/jpg-png/msc-2.jpg',
                    webp_url: '/assets/images/office/webp/msc-2.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 628,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/msc-3.jpg',
                    webp_url: '/assets/images/office/webp/msc-3.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 628,
                    height: 354,
                },
            ],
        },
    ],
    'cromi.rent': [
        {
            swiperClass: 'swiper-saint-contact',
            city: 'Санкт-Петербург',
            address: 'пр. Маршала Блюхера 12к7',
            phone: '+7 812 490-60-30',
            tel: '+78124906030',
            email: 'info@cromi.ru',
            images: [
                {
                    url: '/assets/images/office/jpg-png/spb-1.jpg',
                    webp_url: '/assets/images/office/webp/spb-1.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-2.jpg',
                    webp_url: '/assets/images/office/webp/spb-2.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-3.jpg',
                    webp_url: '/assets/images/office/webp/spb-3.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-4.jpg',
                    webp_url: '/assets/images/office/webp/spb-4.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 627,
                    height: 354,
                },
            ],
        },
        {
            swiperClass: 'swiper-saint-contact',
            city: 'Москва',
            address: 'Кусковская улица, 20А',
            phone: '+7 499 499-60-30',
            tel: '+74994996030',
            email: 'info@cromi.ru',
            images: [
                {
                    url: '/assets/images/office/jpg-png/msc-1.jpg',
                    webp_url: '/assets/images/office/webp/msc-1.webp',
                    alt: '',
                    width: 628,
                    height: 387,
                },
                {
                    url: '/assets/images/office/jpg-png/msc-2.jpg',
                    webp_url: '/assets/images/office/webp/msc-2.webp',
                    alt: '',
                    width: 628,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/msc-3.jpg',
                    webp_url: '/assets/images/office/webp/msc-3.webp',
                    alt: '',
                    width: 628,
                    height: 354,
                },
            ],
        },
    ],
    'radioguide.rent': [
        {
            swiperClass: 'swiper-saint-contact',
            city: 'Санкт-Петербург',
            address: 'пр. Маршала Блюхера 12к7',
            phone: '+7 812 490-60-30',
            tel: '+78124906030',
            email: 'info@cromi.ru',
            images: [
                {
                    url: '/assets/images/office/jpg-png/spb-1.jpg',
                    webp_url: '/assets/images/office/webp/spb-1.webp',
                    alt: '',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-2.jpg',
                    webp_url: '/assets/images/office/webp/spb-2.webp',
                    alt: '',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-3.jpg',
                    webp_url: '/assets/images/office/webp/spb-3.webp',
                    alt: '',
                    width: 627,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/spb-4.jpg',
                    webp_url: '/assets/images/office/webp/spb-4.webp',
                    alt: '',
                    width: 627,
                    height: 354,
                },
            ],
        },
        {
            swiperClass: 'swiper-saint-contact',
            city: 'Москва',
            address: 'Кусковская улица, 20А',
            phone: '+7 499 499-60-30',
            tel: '+74994996030',
            email: 'info@cromi.ru',
            images: [
                {
                    url: '/assets/images/office/jpg-png/msc-1.jpg',
                    webp_url: '/assets/images/office/webp/msc-1.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 628,
                    height: 387,
                },
                {
                    url: '/assets/images/office/jpg-png/msc-2.jpg',
                    webp_url: '/assets/images/office/webp/msc-2.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 628,
                    height: 354,
                },
                {
                    url: '/assets/images/office/jpg-png/msc-3.jpg',
                    webp_url: '/assets/images/office/webp/msc-3.webp',
                    alt: '',
                    mime_type: '',
                    title: '',
                    type: 'image',
                    width: 628,
                    height: 354,
                },
            ],
        },
    ],
}
